import { directiveSettings } from '../../utils/parse';
import { onScroll } from '../../utils/window';
/**
 * @module directives/inspect/inspect-scroll
 */

/**
 * Toggles a class on an element on scroll.
 */
export default function inspectScrollDirective() {

  // for each scroll inspector toggle hidden class on scoll
	document.querySelectorAll('[data-sw-inspect-scroll]').forEach(element => {
		const data = element.getAttribute('data-sw-inspect-scroll'),
    settings = directiveSettings(data, {
      target: null,
      class: 'is-scrollable',
      inverted: false,
    }, 'target'),
    target = document.getElementById(settings.target) || element;

    if (target) {
      const scroll = _ => {
        const scrolling = target.scrollWidth - target.clientWidth > 0 || target.scrollHeigth - target.clientHeight > 0;
        element.classList.toggle(settings.class, settings.inverted ? !scrolling : scrolling);
      }
      onScroll(scroll);
      scroll();
    }
	});
}



// WEBPACK FOOTER //
// ./source/scripts/directives/inspect/inspect-scroll.js